module.exports = __webpack_public_path__ + "docs/img/debuger.68fbf149.jpg";